// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDrZmynpDiKEqPWzRXZ8eseOz_pgi96USM",
  authDomain: "medicare-hospital-f26fd.firebaseapp.com",
  projectId: "medicare-hospital-f26fd",
  storageBucket: "medicare-hospital-f26fd.appspot.com",
  messagingSenderId: "250859249469",
  appId: "1:250859249469:web:11023c9c19df5401da2f54"
};

export default firebaseConfig;